/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconBlockFilled8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlockFilled8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 .667a3.333 3.333 0 1 0 0 6.666A3.333 3.333 0 0 0 4 .667ZM2.374 2.373A2.3 2.3 0 0 1 5.22 2.05L2.05 5.22a2.3 2.3 0 0 1 .323-2.847ZM4 6.3a2.3 2.3 0 0 1-1.22-.35l3.17-3.17A2.3 2.3 0 0 1 4 6.3Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBlockFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlockFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1ZM3.56 3.56a3.45 3.45 0 0 1 4.27-.485L3.075 7.83a3.45 3.45 0 0 1 .485-4.27ZM6 9.45a3.45 3.45 0 0 1-1.83-.524L8.926 4.17A3.45 3.45 0 0 1 6 9.45Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBlockFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlockFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.334ZM4.746 4.748A4.6 4.6 0 0 1 10.44 4.1L4.1 10.44a4.601 4.601 0 0 1 .646-5.693ZM8 12.6a4.6 4.6 0 0 1-2.44-.7l6.34-6.34A4.6 4.6 0 0 1 8 12.6Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBlockFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlockFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM7.12 7.12a6.901 6.901 0 0 1 8.54-.97l-9.51 9.51a6.901 6.901 0 0 1 .97-8.54ZM12 18.901c-1.304 0-2.57-.369-3.66-1.05l9.511-9.51A6.901 6.901 0 0 1 12 18.9Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconBlockFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBlockFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconBlockFilled8 {...iconProps} />;
        case '12':
            return <IconBlockFilled12 {...iconProps} />;
        case '16':
            return <IconBlockFilled16 {...iconProps} />;
        case '24':
            return <IconBlockFilled24 {...iconProps} />;
        default:
            return <IconBlockFilled24 {...iconProps} />;
    }
});
